import apiClient from "../../utils/interceptor";
import { API_URLS } from "../../constants";
import {
  ApiResponse,
  CalibrationRequestParams,
  CombinedCalibrationResponse,
} from "./interface";

// Helper to get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

export const getCalibrationData = async (
  params: CalibrationRequestParams
): Promise<ApiResponse<CombinedCalibrationResponse>> => {
  const token = getAuthToken();
  try {
    const response = await apiClient.post<
      ApiResponse<CombinedCalibrationResponse>
    >(API_URLS.CALIBRATION.GET_CALIBRATION_DATA, params, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching calibration data:", error);
    throw error;
  }
};
